module.exports = __webpack_public_path__ + "img/schedule_active.021b78e4.svg";